import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/storage";

export const config = {
  apiKey: "AIzaSyAinLtRSBWWOHhN_0rSXRKBXNtAxjJxQQo",
  authDomain: "creditzmusic.firebaseapp.com",
  databaseURL: "https://creditzmusic.firebaseio.com/",
  projectId: "creditzmusic",
  storageBucket: "creditzmusic.appspot.com",
  messagingSenderId: "61907740853",
  appId: "1:61907740853:web:6f630dabb6b166fa70b6fc",
  measurementId: "G-QK8PDJF29M"
};

firebase.initializeApp(config);

export const database = firebase.database();
export const storage = firebase.storage();
export const auth = firebase.auth();
export const firestore=firebase.firestore();
export default firebase;
